const EVENT_SCREEN_NAMES = {
  NFO: "nfo",
  SELECT_DATE: "select_a_date",
  NFO_ORDER: "nfo_order_screen",
  NFO_DETAILS_PAGE: "nfo_detail_page",
  HIGH_GROWTH_FUNDS: "high growth funds",
  RECOMMENDED_FUNDS: "recommended funds",
  CHANGE_RISK_PROFILE: "change risk profile",
  CUSTOMISE_DISTRIBUTION: "customise equity-debt distribution",
  HOW_WE_RECOMMEND: "how we recommend?",
  EDIT_FUNDS: "edit funds",
  REPLACE_WITH: "replace with",
  SELECT_SIP_DATE: "select sip date",
  SELECT_RISK_PROFILE: "select risk profile",
  HAVE_REFERRAL_CODE: "have a bank referral code?",
  MINIMUM_INVESTMENT_AMOUNT: "minimum investment amount",
  SAVE_TAX_INFO: "save tax info",
  SAVE_TAX: "save tax",
  SELECT_A_DATE: "select a date",
  INVEST_FOR_A_GOAL: "invest for a goal",
  SELECT_A_YEAR: "select a year",
  SELECT_THE_AMOUNT_YOU_WANT_TO_SAVE: "select the amount you want to save",
  SIP_AMOUNT_DETAILS: "SIP amount details",
  TARGET_AMOUNT_DETAILS: "Target amount details",
  PARK_MY_SAVINGS: "park your savings",
};

export default EVENT_SCREEN_NAMES;
